import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function PublicHeader() {
  return (
    <header className="border-b border-border bg-background/80 backdrop-blur-xl sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
        <Logo />
        <nav className="flex items-center gap-3 sm:gap-6 text-sm">
          <Link to="/influencer-directory" data-testid="public-nav-directory" className="hidden sm:inline text-muted-foreground hover:text-foreground">Influencer directory</Link>
          <Link to="/?join=1" data-testid="public-nav-signin" className="rounded-full bg-neon-lime text-background px-4 py-2 font-semibold hover:opacity-90">Sign in / Sign up</Link>
        </nav>
      </div>
    </header>
  );
}

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="text-sm text-muted-foreground mb-4" data-testid="seo-breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((c, i) => (
          <li key={c.path} className="flex items-center gap-1.5">
            {i > 0 && <span aria-hidden="true">/</span>}
            {i === items.length - 1 ? <span className="text-foreground font-medium">{c.label}</span> : <Link to={c.path} className="hover:text-foreground">{c.label}</Link>}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function SeoHead({ title, description, canonical, robots, ogType = "website", jsonLd }) {
  return (
    <>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {robots && <meta name="robots" content={robots} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={ogType} />
      {canonical && <meta property="og:url" content={canonical} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </>
  );
}
